import { StoneXModal } from "../../../../StoneXMui";
import UpdateAllocation from "./UpdateAllocation";
import { AllocationModel, PositionModel } from '../../../../../Generated/Commodity-Management-Api';

interface UpdateAllcoationsModalProps {
  allocationModel?: AllocationModel;
  positions?: PositionModel[];
  open: boolean;
  onClose: () => void;
  onCancel?: () => void;
  onSave: (allocationId: number) => void;
  onDelete: (allocationId: number) => void;
}

export function UpdateAllocationsModal(props: UpdateAllcoationsModalProps) {

  const { allocationModel, open, onClose, onSave, onDelete, positions} = props;

  return <StoneXModal width='95%' header={allocationModel ? 'Update Allocation' : 'Add Allocation'} open={open} onClose={onClose} sx={{maxWidth: '95%', maxHeight: '90%'}} height={'90%'}>
      <UpdateAllocation allocationModel={allocationModel} allPositions={positions}  onSave={onSave} onDelete={onDelete} onCancel={onClose}/>
  </StoneXModal>
}